import React, { useRef, useEffect, useState } from "react";
// import {useAsync } from "react-async";
import { useAsync, useAsyncCallback } from "react-async-hook";

import Grid, {GridObject} from '../Grid/Grid';
import TableForm, {TableFormObject} from '../TableForm/TableForm';
import Login from '../Login/Login';
import fetch from 'node-fetch';

import "./styles.css";

// Server location
//const serverurl = 'http://localhost:3001';
const serverurl = 'https://tagger.visiblecharges.com/taggerservice';
const lintserverurl = 'https://tagger.visiblecharges.com';
//const serverurl ='http://184.73.26.186:3001'; // New visiblecharges account
const HEADER_SEP = '‖';

interface Settings {
  tableid: string;
  table: any;
  file: any;
  facility: any;
  tableformat: string;
  tagging: any;
  auth: boolean;
  error?: string;
  loading: boolean;
  warnings?: string;
};

interface Edited {
  table: any,
  form: any,
};


/*
function initialSettings(): Settings
{
  return {
    tableid: '',
    table: {},
    file: {},
    facility: {},
    error: ''
  }
}
*/

// let currentSettings: Settings = initialSettings();

interface EditorProps {
  tableid: string;
}

function Editor(props: EditorProps) {

  // Information we have for editing
  const emptySettings = {
    tableid: '',
    table: {},
    file: {},
    facility: {},
    tagging: {},
    tableformat: '',
    loading: true,
    auth: true,
    error: '',
    warnings: ''
  }

  const [currentSettings, setCurrentSettings] = useState<Settings>(emptySettings);


  function clearSettings(auth: boolean)
  {
    const settings = {...emptySettings, auth: auth};
    setCurrentSettings(settings);
  }

  function setError(error: string, auth: boolean)  
  {
    const settings = {...currentSettings};
    settings.auth = auth;
    settings.loading = false;
    settings.error = error;
    setCurrentSettings(settings);
  }

  function setWarnings(warnings: string[])
  {
    const settings = {...currentSettings};
    settings.loading = false;    
    settings.warnings = warnings.join("; ");
    settings.auth = true;
    setCurrentSettings(settings);
  }

  function setLoading()
  {
    const settings = {...currentSettings};
    settings.loading = false;
    setCurrentSettings(settings);
  }


  async function fetchrecord(fetchnew: boolean = false) {
    // Include the current/previous tableid, if known. This allows all tables
    // belonging to the same file/facility to be edited.

    let tableid = null;
    let lasttableid = null;
    if (!fetchnew && props && props.tableid) {
      tableid = props.tableid;
    }
    if (fetchnew && currentSettings.tableid) {
      lasttableid =  currentSettings.tableid;
    }
    setLoading();

    // Ex: localhost:3001/table/review
    let endpoint = `${serverurl}/table/review/`;
    if (lasttableid) {
      endpoint = `${serverurl}/table/review/last/${lasttableid}`;
    } else if (tableid && tableid.length > 0) {
      // Return the last edited table, to help influence the next table returned
      endpoint = `${serverurl}/table/review/${tableid}`;
    }
  
    // console.log('**** calling fetch', endpoint);
    
    const response = await fetch(endpoint);
    if (response.status != 200) {
      // clearSettings(false);
      const auth = (response.status < 400) || (response.status >= 500);
      let message = '';
      try {
	const data = await response.json();
	if (data.message) {
	  message = data.message;
	}
      }
      catch (ex) {
      }
      setError('Failed to load data: ' + message , auth);
      return;
    }
    const data = await response.json();
    
    // console.log('***** result', data.data);
    
    if ('data' in data) {
      if (data.data === null) {
        // No records available to edit
        console.log('No records available on server');
        clearSettings(true);
	if (tableid) {
          setError('The specified table is not available on the server', true);
	} else {
          setError('No tables are available on the server', true);
	}
      }
      else {
        let nurl = new URL(window.location.href);
        nurl.searchParams.set('tableid', data.data.table.tableid);
        const url = nurl.toString();
        if (url != window.location.href) {
          // console.log('New href', url);
          window.location.href = nurl.toString();
          return;
        }
	
        // Valid data
        // clearSettings();
        const settings: Settings = {
          table: data.data.table,
	  tagging: data.data.tagging, // Can be null
          file: data.data.file,
          facility: data.data.facility, // Can be null
          tableid: data.data.table.tableid,
	  tableformat: data.data.table.format,
	  loading: false,
	  auth: true
        }
        //console.log('setCurrentSettings', settings);
        setCurrentSettings(settings);

      }
    }

/*
        // Check if the url was in the browser; otherwise, redirect to display the page so it's clean
        if (!tableid || tableid.length == 0) {
          let nurl = new URL(window.location.href);
          nurl.searchParams.set('tableid', tableid);
          // We did a normal fetch. Now get the url and redirect. Strip off any guid at the end
          const ourl = window.location.href;
          const p = ourl.lastIndexOf('/');
          let url = ourl;
          if (p < 0 || p == ourl.length-1) {
            url = `${ourl}/${data.data.table.tableid}`;
          }
          else {
            const field = url.substr(p+1);
            if (field && field.length == 36) {
              // Remove this field with the new field
              url = url.replace(field, data.data.table.tableid);
            }
            else {
              url = `${url}/#{data.data.table.tableid}`;
            }
          }
          
          window.location.href = url;
          return;
        }

        // Valid data
        // clearSettings();
        const settings: Settings = {
          table: data.data.table,
          file: data.data.file,
          facility: data.data.facility, // Can be null
          tableid: data.data.table.tableid
        }
        //console.log('setCurrentSettings', settings);
        setCurrentSettings(settings);
      }
    }
*/
    else {
      // invalid data
      console.log('Invalid data read from server');
      clearSettings(true);
      setError("Invalid data", true);
    }
    
  
    //console.log('settings', settings);
    //currentSettings = settings;
    //return settings;
  
  }
  
  async function cancelrecord(tableid: string) {
    const endpoint = `${serverurl}/table/cancel/${tableid}`;
  
    const response = await fetch(endpoint, {
      method: 'PUT'
    });
    const json = await response.json();
  }
  
  async function saveforlater(tableid: string, edited: {}): Promise<string> {
    const endpoint = `${serverurl}/table/saveforlater/${tableid}`;
    
    let message = '';

    try {
      const response = await fetch(endpoint, {
	method: 'PUT',
	body: JSON.stringify(edited),
	headers: { 'Content-Type': 'application/json' }
      });
      const json = await response.json();  
    }
    catch (ex) {
      message = ex.toString();
      console.log('Error during save', ex);
    }
    return message;
  }

  async function logout(): Promise<string> {
    const endpoint = `${serverurl}/logout`;
  
    try {
    const response = await fetch(endpoint, {
      method: 'POST'
    });
      const json = await response.json();
    }
    catch (ex) {
      const message = ex.toString();
      console.log('Error during logout', ex);
    }
    return 'done';
  }
  
  async function save(tableid: string, edited: {}): Promise<string> {
    const endpoint = `${serverurl}/table/save/${tableid}`;
  
    let message = ''; // 'unknown error';
  
    try {
      const response = await fetch(endpoint, {
        method: 'PUT',
        body: JSON.stringify(edited),
        headers: { 'Content-Type': 'application/json' }
      });
      const json = await response.json();  
      //console.log('Saving placeholder', json);
      //TODO Remove error if everything is ok
    }
    catch (ex) {
      message = ex.toString();
      console.log('Error during save', ex);
    }
  
    return message;
  }

  function transformtotagging(griddata: Edited): { ignoreTable: boolean} {
    // New values to write
    const newcolumns = [];
    const newtypes = [];
    const newattributes = [];
    const newtags = [];
    const formupdates = griddata['form'];
    const tableupdates = griddata['table'];

    for (const row of tableupdates.rows) {
      // Always two column names, but the second is usually missing
      let name = '';
      if (row.columnNames[1] && row.columnNames[1].length > 0) {
        name = row.columnNames.join(HEADER_SEP);
      }
      else {
        name = row.columnNames[0];
      }

      newcolumns.push(name);
      newtypes.push(row.columnType);
      newattributes.push(row.attributes); // This is an array
      newtags.push(row.tags);
    }

    const tagging = {
      columntypes: newtypes,
      attributes: newattributes,
      tags: newtags,
      dates: formupdates['dates'],
      payer: formupdates['payer'],
      setting: formupdates['setting'],
      facilityId: formupdates['facilityId'],
      facilityName: formupdates['facilityName'],
      ignoreTable: formupdates['ignoreTable']
    }
    return tagging
  }

  async function validate(tableformat: string, edited: Edited): Promise<any> {
    const endpoint = `${lintserverurl}/validate`;
  
    let json = []; // 'unknown error';
    const tagging = transformtotagging(edited);
    // No need to validate the tags since the table is ignored.
    if (tagging['ignoreTable']) {
      return [];
    }
    const data = {'tagging': tagging,
		  'format': tableformat};
    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: { 'Content-Type': 'application/json' }
      });
      json = await response.json();
      //console.log('Saving placeholder', json);
      //TODO Remove error if everything is ok
    }
    catch (ex) {
      // let message = ex.toString();
      console.log('Error during validate', ex);
    }
  
    return json;
  }

  
  // Allow the Editor to call the grid for current grid values
  const gridRef = useRef<GridObject>(null);
  const tableformRef = useRef<TableFormObject>(null);

  async function buildPayload (validateTagging: boolean) {
    // Get the current editor settings
    if (!gridRef.current) {
      console.log('Cannot Save because there is no grid');
      return null;
    }
    if (!tableformRef.current) {
      console.log('Cannot Save because there is no tableform');
      return null;
    }

    // gridsettings contains
    // columnNames: Array of two names
    // columnType: column type
    // attributes, Array of attributes
    // tags: as entered string. Hopefully comma separated
    const gridsettings = gridRef.current.getSettings();

    // formsettings contains
    // ignoreTable: boolean
    // dates: Array of two dates, which are often ''
    // facilityId: string
    // facilityName: string
    // payer: string
    // ...
    const formsettings: any = tableformRef.current.getSettings();

    //console.log('RETRIEVED SETTINGS', gridsettings);

    const edited = {
      table: gridsettings,
      form: formsettings
    }

    if (formsettings.ignoreTable && !formsettings.ignoreReason) {
      setWarnings(['You must provide a reason for ignoring the table.  Table not saved.']);
      return null;
    }

    if (validateTagging) {
      const validationdata: any  = await validate(currentSettings.tableformat, edited);
      if (validationdata.length != 0) {
	// set errors so they are shown
	setWarnings(validationdata);
	return null;
      }
    }
    return edited;

  }

  const onSave = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  
    const edited = await buildPayload(true);
    if (!edited) {
      return;
    }

    // Save
    const message: string = await save(currentSettings.tableid, edited);
    if (message && message.length > 0) {
      console.log('Saving returned an error', message);
      return;
    }

    // Fetch a new record
    const data = await fetchrecord(true);
    //if (data) {
    //  console.log('settings change');
    //  //setSettings(data);
    //}   

  };

  // This is no longer used since we didn't know what table to load
  // after this once was canceled.  By default, the system was often reloading
  // the same table.
  const onCancel = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    console.log('onCancel', currentSettings);
  
    await cancelrecord(currentSettings.tableid);
    clearSettings(true);
    //TODO Submit results
  };

  const onLogout = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  
    
    await logout();
    clearSettings(false);

  };

  // login is done in the form.
  const postLogin = async () => {
    await fetchrecord(false);
  };

  const onLater = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    if (tableformRef && tableformRef.current) {
      const formsettings: any = tableformRef.current.getSettings();
      if (formsettings && formsettings.puntedReason == '') {
	setWarnings(['You must provide a reason for skipping this table.']);
	return;
      }     
    }

    const edited = await buildPayload(false);
    if (!edited) {
      return;
    }

    let message: string = await saveforlater(currentSettings.tableid, edited);
    if (message && message.length > 0) {
      console.log('Saving later returned an error', message);
      return;
    }

    // Fetch a new record
    const data = await fetchrecord(true);
    //if (data) {
    //  console.log('settings change');
    //  //setSettings(data);
    //}

  };



  const saveclick = useAsyncCallback(onSave);
  const laterclick = useAsyncCallback(onLater);

  const currentData = useAsync(fetchrecord, []);
  

  if (!currentSettings.auth) {
    return (<Login postloginfunction={postLogin}/>);
  }

  if (currentSettings.loading) {
    return (<div>Loading</div>);
  }
  if (currentSettings && currentSettings.error) {
    return (<div className='warnings'>Error: {currentSettings.error}</div>);
  }

  // console.log('Editor props', props);

  /*
  //const settings = currentData.result;
  setSettings(currentData.result);

  if (settings && settings.error && settings?.error.length > 0) {
    return (<div>Settings Error: {settings.error}</div>);
  }
  */

  // if (currentData.result.tableid !== )

  /* 
  const skipDisabled = () => {
    console.log("called to check on button");
    return ((!tableformRef.current) ||
      !tableformRef.current.getSettings().puntedReason);
  }
  */
  // removed the cancel button since it isn't clear what should load after a cancel and we
  // didn't want it to reload the same table.
  /* <button id="cancel" name="cancel" onClick={onCancel} >Cancel</button> */

  
  return (
    <div style={{textAlign: 'left'}}>
      <div id="buttons_div">
      <button id="save" name="save" onClick={saveclick.execute}>Save</button>
      <button id="later" name="later" onClick={laterclick.execute} >Skip</button>
      <button id="logout" name="logout" onClick={onLogout} >Logout</button>
      </div>
      {currentSettings && currentSettings.warnings ? <div className='warnings'>{currentSettings.warnings}</div>: ''}
      <TableForm ref={tableformRef} initialSettings={currentSettings} initialtableid={currentSettings ? currentSettings.tableid : ''}
                 tagging={currentSettings ? currentSettings.tagging : null}/>
      <Grid ref={gridRef} tableid={currentSettings ? currentSettings.tableid : ''} table={currentSettings ? currentSettings.table : {}}
            file={currentSettings ? currentSettings.file : {}}
            facility={currentSettings ? currentSettings.facility : {}}
            tagging={currentSettings ? currentSettings.tagging : null}/>
      </div>
  );
  //}

  //return (<div></div>);
}

export default Editor;
